@let isMenuPage = pageIs().menu;
@let isPromosTable = pageIs().promos;
@let isServicePage = pageIs().service;
@let isMorePage = pageIs().more;
@let callWaiterMain = this.callWaiterMain();

<div
  [class.hide]="hideTabBar()"
  class="tab-bar"
>
  <div class="tabs" coreActivitySection="TabBar">
    <button
      class="tab"
      [class.active]="isMenuPage"
      [routerLink]="isMenuPage ? '/main/home' : '/main/menu'"
      [coreUserActivityClickTracking]="isMenuPage ? 'MenuClose' : 'MenuOpen'"
    >
      <svg width="64" height="63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M49.9 47.3h1-1Zm-36.8-9h1a1 1 0 0 0-.6-1l-.4 1Zm36.8 0-.4-1a1 1 0 0 0-.6 1h1Zm-7.6-20a1 1 0 1 0 2 0h-2Zm-23.6 0a1 1 0 1 0 2 0h-2Zm-.3-5.2v-1c-7.8 0-14.1 6.3-14.1 14.2h2c0-6.7 5.4-12.2 12-12.2v-1Zm26.2 0v1c6.7 0 12.1 5.5 12.1 12.2h2c0-7.9-6.3-14.2-14-14.2v1Zm-5.2 44.6v-1H23.6v2h15.8v-1Zm-15.8 0v-1l-5.6-.1c-1.3-.2-2-.5-2.6-1l-.7.6-.7.7c1 1 2.2 1.4 3.7 1.6 1.5.3 3.5.3 6 .3v-1ZM13.1 47.3h-1c0 2.5 0 4.4.2 6 .2 1.5.7 2.7 1.7 3.7l.7-.7.7-.7c-.6-.5-1-1.3-1-2.6-.3-1.4-.3-3.1-.3-5.6h-1Zm36.8 0h-1c0 2.6 0 4.3-.2 5.7-.2 1.3-.5 2-1 2.6l.6.7.7.7c1-1 1.5-2.2 1.7-3.8.2-1.5.2-3.4.2-5.9h-1ZM39.4 57.8v1c2.4 0 4.4 0 5.9-.2S48 58 49 57l-.7-.7-.7-.7c-.5.6-1.3.9-2.6 1-1.3.2-3.1.3-5.6.3v1Zm-21-44.6v1c.6 0 1.2 0 1.8.2l.1-1 .2-1-2.1-.2v1Zm13.1-7.8v-1c-5.6 0-10.4 3.6-12.1 8.6l1 .4.9.3c1.4-4.3 5.4-7.3 10.2-7.3v-1Zm-11.2 8-1-.4c-.4 1.3-.6 2.7-.6 4.2h2c0-1.3.2-2.4.6-3.5l-1-.3Zm24.3-.2v-1c-.7 0-1.4 0-2 .2v1l.2 1 1.8-.2v-1ZM31.5 5.3v1c4.8 0 8.8 3 10.2 7.3l1-.3 1-.4C41.8 8 37 4.2 31.4 4.2v1Zm11.2 8-1 .3c.4 1 .6 2.2.6 3.5h2c0-1.5-.2-2.9-.7-4.2l-1 .4ZM13 47.3h1v-9h-2v9h1Zm0-9 .4-1a12.1 12.1 0 0 1-7.3-11h-2c0 5.7 3.5 10.7 8.5 12.9l.4-1Zm36.8 0h-1v9h2v-9h-1Zm7.9-12h-1c0 5-3 9.2-7.3 11l.4 1 .4.9c5-2.2 8.5-7.2 8.5-13h-1ZM43.3 17h-1v1.3h2V17h-1Zm-23.6 0h-1v1.3h2V17h-1Z"
          fill="currentColor"/>
        <path d="M13.1 47.3H50" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <div class="label">Menu</div>
      <div class="lumen">
        <img src="/images/lumen.svg" alt="Lumen">
      </div>
    </button>

    <button
      class="tab"
      [class.active]="isPromosTable"
      [routerLink]="isPromosTable ? '/main/home' : '/main/promos'"
      [coreUserActivityClickTracking]="isPromosTable ? 'PromosTableClose' : 'PromosTableOpen'"
    >
      <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.5 42.9c-4-4.1-6-6.1-6.8-8.8-.8-2.6-.1-5.4 1.2-11l.7-3.2c1.1-4.7 1.6-7 3.3-8.7 1.6-1.6 4-2.1 8.6-3.2l3.2-.7c5.6-1.3 8.4-2 11-1.2 2.7.7 4.7 2.8 8.8 6.8l4.8 4.8c7 7 10.6 10.6 10.6 15s-3.6 7.9-10.6 15c-7 7-10.6 10.5-15 10.5s-7.9-3.5-15-10.5l-4.8-4.8Z"
          stroke="currentColor" stroke-width="2"/>
        <circle cx="22.7" cy="23.8" r="5.3" transform="rotate(-45 22.7 23.8)" stroke="currentColor" stroke-width="2"/>
        <path d="m30.4 49 18.3-18.3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <div class="label">Promos</div>
      <div class="lumen">
        <img src="/images/lumen.svg" alt="Lumen">
      </div>
    </button>

    <button
      class="tab"
      [class.active]="isServicePage"
      [routerLink]="isServicePage ? '/main/home' : '/main/service'"
      [coreUserActivityClickTracking]="isServicePage ? 'ServiceClose' : 'ServiceOpen'"
    >

      <svg class="icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M53.965 56.258h-43.93A7.566 7.566 0 0 1 2.47 48.69v-2.903H61.53v2.903a7.566 7.566 0 0 1-7.566 7.566ZM32 18.928a5.593 5.593 0 1 0 0-11.186 5.593 5.593 0 0 0 0 11.186Z"
          stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path
          d="M54.512 33.277c-3.95-8.475-12.545-14.35-22.512-14.35m0 0c-13.71 0-24.824 11.115-24.824 24.825v2.036H42.53M32 18.928c13.71 0 24.825 11.114 24.825 24.824v2.036"
          stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <div class="label">Service</div>
      <app-call-waiter-indicator
        [type]="callWaiterMain ? 'assistance' : 'bill'"
        class="indicator"
      />
      <div class="lumen">
        <img src="/images/lumen.svg" alt="Lumen">
      </div>
    </button>

    <button
      class="tab"
      [class.active]="isMorePage"
      [routerLink]="isMorePage ? '/main/home' : '/main/more'"
      [coreUserActivityClickTracking]="isMorePage ? 'MoreClose' : 'MoreOpen'"
    >
      <svg class="icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M53 18.875H11M53 32H11M53 45.125H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <div class="label">More</div>
      <div class="lumen">
        <img src="/images/lumen.svg" alt="Lumen">
      </div>
    </button>
  </div>
</div>

@if (hideTabBar()) {
  <core-interacts-present/>
}
